<template>
  <div :class="{title: true, center: center}">
    <router-link to="/"><img src="@/assets/logo.png" width="70"></router-link>
    <h3 class="text-center">{{ title }}</h3>
    <div class="dropdown" v-if="$store.getters.loggedIn">
      <button class="dropdown-toggle ion-md-person" data-toggle="dropdown"></button>
      <div class="dropdown-menu dropdown-menu-right shadow-lg">
        <div class="dropdown-item">
          <h5 class="ion-md-person"> {{ $store.state.user.user.name }}</h5>
          <h6 class="ion-md-mail" @click="$router.replace('/me')"> {{ $store.state.user.user.email }}</h6>
          <hr/>
          <div class="center">
            <button class="btn btn-primary ion-md-person" v-if="!$store.state.user.user.facebookId" @click="$router.replace('/me')"> edit</button>
            <button class="btn btn-danger ion-md-key rounded-0" style="border-radius: 3px !important;" @click="logout"> logout</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {

    name: "z-nav",

    props: {
      title: {
        type: String,
        default: "NIIEV Consultation Tool"
      },
      center: {
        type: Boolean,
        default: false
      }
    },

    methods: {
      logout() {
        this.$store.commit("logout");
        this.$router.replace("/");
      }
    }

  }
</script>

<style scoped>

  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    text-align: center;
    max-width: 1360px;
    margin: 0 auto;
    padding: 10px 30px;
  }

  .center h3 {
    flex-grow: 1;
  }

  .dropdown-toggle {
    background: #009688;
    color: white;
    padding: 10px !important;
    width: 70px;
    height: 70px;
    border-radius: 50% !important;
  }

  h2 {
    font-size: 1.8em;
  }

</style>